import { useEffect } from 'react'
import store from '../../store'
import {
  getGanttParameter,
  receivedProjectGanttParameter,
  receivedRootGanttParameter,
} from '../../store/project'

export const useProjectGanttParameter = (projectUuid: string | undefined) => {
  useEffect(() => {
    if (!projectUuid) return
    let disposed = false
    getGanttParameter(projectUuid).then(parameter => {
      if (disposed) return
      store.dispatch(receivedProjectGanttParameter(parameter))
    })
    return () => {
      disposed = true
    }
  }, [projectUuid])
}

export const useRootGanttParameter = (
  projectUuid: string | undefined,
  rootProjectPlanUuid: string | undefined
) => {
  useEffect(() => {
    if (!projectUuid || !rootProjectPlanUuid) {
      store.dispatch(receivedRootGanttParameter(undefined))
      return
    }
    let disposed = false
    getGanttParameter(projectUuid, rootProjectPlanUuid).then(parameter => {
      if (disposed) return
      store.dispatch(receivedRootGanttParameter(parameter, rootProjectPlanUuid))
    })
    return () => {
      disposed = true
    }
  }, [projectUuid, rootProjectPlanUuid])
}
